import { queries } from './queries';

export const requests = {
  queries,
};
